import React, { Component } from 'react';

import Row from './Row';
import Cell from './Cell';
import PropTypes from 'prop-types';

export default class SectionHeader extends Component {
    render() {
        const style = {
            minWidth: `${225 + this.props.channelCount * 45}px`,
        };

        return (
            <Row className="grid-section-header" style={style}>
                <Cell alignLeft noBorder>
                    {this.props.children}
                </Cell>
            </Row>
        );
    }
}

SectionHeader.propTypes = {
    channelCount: PropTypes.string.isRequired,
    children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/SectionHeader.js